import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Badge as MaterialBadge, Tooltip as MaterialTooltip } from '@material-ui/core';

export const Badge = withStyles(theme => ({
  badge: {
    backgroundColor: '#44b700',
    boxShadow: `0 0 0 1px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$throb 1.2s infinite ease-in-out',
      border: '1px solid #44b700',
      content: '""',
    },
  },
  '@keyframes throb': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(MaterialBadge);

export const Tooltip = withStyles({
  tooltip: {
    fontSize: 12
  }
})(MaterialTooltip);

export default makeStyles(theme => ({
  header: {
    backgroundColor: ({HEADER_COLOR}) => HEADER_COLOR,
    padding: '10px 25px',
    color: 'white',
    display: 'flex',
    justifyContent: ({HEADER_SHOW_NAME}) => HEADER_SHOW_NAME ? 'space-between' : 'center',
    [theme.breakpoints.up('md')]: {
      display: ({WIDE_MODE, FULLSCREEN_SMALL_WIDGET}) => WIDE_MODE && !FULLSCREEN_SMALL_WIDGET ? 'none' : 'auto'
    }
  },
  headerTitle: {
    display: 'flex'
  },
  profileImage: {
    flex: 1,
    height: 30,
    maxWidth: 30
  },
  headerText: {
    marginLeft: 15,
    fontSize: 15,
    fontWeight: 'bold',
    marginBlockStart: '0.67em',
    marginBlockEnd: '0.67em',
    lineHeight: 1.5
  },
  ellipsisIcon: {
    padding: 8,
    cursor: 'pointer',
    fill: 'white'
  },
  menuList: {
    borderTopRightRadius: 0,
    padding: 0,
    borderRadius: 8
  },
  inlineMenu: {
    maxWidth: 'max-content'
  },
  inlineMenuItem: {
    backgroundColor: 'transparent',
    color: 'white',
    minHeight: '40px',
    minWidth: '40px',
    justifyContent: 'center',
    fontSize: 16,
    fontFamily: ({FONT_FAMILY}) => FONT_FAMILY,
    padding: 0,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      transform: 'scale(1.1)',
    }
  },
  inlineMenuItemIcon: {
    fontSize: 'inherit'
  },
  menuItem: {
    color: 'black',
    fontSize: 14,
    fontFamily: ({FONT_FAMILY}) => FONT_FAMILY,
    padding: '8px 25px',
    '&:hover': {
      backgroundColor: '#b6d6f73d',
      fontWeight: 'bold',
      color: ({GLOBAL_COLOR}) => GLOBAL_COLOR,
    }
  },
  menuItemIcon: {
    fontSize: 'inherit',
    marginRight: 10
  }
}));
